import { render, staticRenderFns } from "./DigerAlacakFormWizard.vue?vue&type=template&id=646dc61c"
import script from "./DigerAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./DigerAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports